import type { MotivoAgregado } from '@/lib/cuadro/agregaciones';
import { textoSinLlamadas } from '@/lib/cuadro/filtros';

// Distribución por motivo (prototipo: motivos) — barras horizontales con
// etiqueta, total y porcentaje. Solo motivos presentes, ya ordenados DESC.

export function DistribucionMotivos({
  motivos,
  periodoVacio,
}: {
  motivos: MotivoAgregado[];
  periodoVacio: boolean;
}) {
  if (motivos.length === 0) {
    return (
      <p data-testid="motivos-vacio" className="text-[12.5px] text-[var(--text-dim)]">
        {textoSinLlamadas(periodoVacio)}.
      </p>
    );
  }
  // como el prototipo: barra navy con ancho relativo al motivo mayor
  const mayor = Math.max(...motivos.map((m) => m.total), 1);
  return (
    <ul className="m-0 list-none space-y-2.5 p-0">
      {motivos.map((m) => (
        <li key={m.motivo} data-testid="motivo-barra" className="text-[12px]">
          <div className="mb-1 flex items-center gap-2 text-[var(--text-2)]">
            <span className="min-w-0 flex-1 truncate">{m.etiqueta}</span>
            <span className="mono font-semibold text-[var(--navy)]">{m.total}</span>
            <span className="mono w-9 text-right text-[var(--text-dim)]">{m.pct}%</span>
          </div>
          <div className="h-1.5 overflow-hidden rounded-full bg-[var(--surface-3)]">
            <div
              className="h-full rounded-full bg-[var(--navy)] opacity-80"
              style={{ width: `${(m.total / mayor) * 100}%` }}
            />
          </div>
        </li>
      ))}
    </ul>
  );
}
